/**
 * Created by shinan.chen on 2021/12/25.
 */
import {getCommon, postCommon } from '../tools';
import * as config from '../config';

export interface INoticeMessage{
    id:number,
    name:string,
    platform:string,
    type:string,
    platformName:string,
    typeName:string,
    studentNames:string,
    teachClassNames:string,
    storeNames:string,
    status:string,
    resultMessage:string,
    creationTime:Date,
    createdBy:string,
}

export const createNoticeMessage = (data:INoticeMessage) =>
    postCommon({
        url: `${config.SERVICE_URL}/notice_message/create`,
        data
    });

export const pageNoticeMessages = (pageNum:number,pageSize:number) =>
    getCommon({
        url: `${config.SERVICE_URL}/notice_message/page?pageNum=${pageNum}&&pageSize=${pageSize}`,
    });